module.exports = __webpack_public_path__ + "static/pokoj-nr4-photo01-b4d105c105834d2746b4db2fcfcd0165.jpg";